import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Button, Modal, Count, Loading } from '../../components/all';
import useAulaStore from '../../store/useAulaStore';
import useUserStore from '../../store/useUserStore';
import useInstrutor from '../../hooks/useInstrutor'
import SendWarning from '../../components/sendWarning';
import toast from '../../utils/toast';

export default function SelectInstructor() {

    const { SearchInstrutorByAluno } = useInstrutor();
    //#region Logica
    const { updateAula, aula } = useAulaStore.getState();
    const { usuario } = useUserStore();

    const [instrutores, setInstrutores] = useState([]);
    const [loading, setLoading] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [selectedInstructor, setSelectedInstructor] = useState(null);
    const [showWarning, setShowWarning] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        const fetchInstructors = async () => {
            if (!usuario || !aula) {
                showToast('Erro', 'Usuário e Tipo são necessários.');
                return;
            }
            setLoading(true);
            setShowWarning(false);
            try {
                const instructorsData = await SearchInstrutorByAluno(usuario.usuario_id, aula.tipo, usuario.autoescola_id);
                setInstrutores(instructorsData || []);
                
                // Se não houver instrutores, esperar 5 segundos antes de exibir o aviso
                if (!instructorsData || instructorsData.length === 0) {
                    setTimeout(() => {
                        setShowWarning(true);
                        setLoading(false);
                    }, 5000);
                } else {
                    setLoading(false);
                }
            } catch (error) {
                showToast('Erro', 'Ocorreu um erro ao buscar os instrutores.');
                console.error(error);
                setLoading(false);
            }
        };

        fetchInstructors();
    }, [usuario, aula, SearchInstrutorByAluno]);

    const showToast = (title, message) => {
        toast.dismiss();
        toast.error(`${title}: ${message}`, { position: 'top-center' });
    };

    const handleButtonClick = (value) => {
        setSelectedInstructor(value);
        setModalVisible(true);
    };

    const confirmSelection = () => {
        setModalVisible(false);
        if (!selectedInstructor) {
            showToast('Erro', 'Selecione um instrutor primeiro.');
            return;
        }
        updateAula('instrutor', selectedInstructor);
        navigate('/selecionarVeiculo');
    };

    const renderInstrutorItem = (item) => (
        <div key={item.instrutor_id} onClick={() => handleButtonClick(item)}
            className="
                flex bg-white shadow-sm p-4 rounded-xl
                border border-gray-200 gap-4 cursor-pointer
                hover:shadow-md hover:border-primary transition
            ">
            <div className='w-full text-start'>
                <h1>Instrutor: </h1>
                <h1 className='font-bold text-3xl sm:text-4xl capitalize'>{item.nome_instrutor}</h1>
                <Button className='mt-2'>
                    Selecionar
                    <span className="material-icons">arrow_forward_ios</span>
                </Button>
            </div>
        </div >
    );

    const onCancel = () => {
        setModalVisible(false);
        setSelectedInstructor(null);
    };

    //#endregion

    return (
        <div className='flex flex-col gap-5 w-full min-h-screen min-h-[100dvh] justify-start sm:justify-center items-center p-3 pt-6 pb-24'>
            <Loading visible={loading} />
            <h1 className='text-2xl font-bold'>Selecionar Instrutor</h1>
            <h2 className='greatText'>
                Clique no instrutor que deseja marcar a aula!
            </h2>
            {instrutores.length === 0 ? (
                <div className='flex flex-col'>
                    {showWarning && <SendWarning text={'instrutor'} />}
                </div>
            ) : (
                <div className='flex flex-col gap-3 max-h-[45dvh] sm:max-h-[400px] overflow-y-auto w-full max-w-[800px] pb-1'>
                    {instrutores.map(renderInstrutorItem)}
                </div>
            )}
            <Count num={2} />
            <Modal
                isOpen={modalVisible}   >
                <p>Você tem certeza que deseja selecionar o instrutor: <strong>{selectedInstructor?.nome_instrutor}</strong></p>
                <div className='grid grid-cols-2 gap-3 mt-4'>
                    <Button onClick={confirmSelection} type={4}>Sim
                        <span className="material-icons">
                            check
                        </span></Button>
                    <Button onClick={() => onCancel()} type={3}>Não
                        <span className="material-icons">
                            close
                        </span>
                    </Button>
                </div>

            </Modal>

            <ToastContainer />
        </div>
    );
};
